import {
  GALLERY_DOWNLOAD_URL
} from 'app/utils/Constants';

import {
  downloadUrl
} from 'shared/services/DownloadService'

export const downloadGallery = (token, momentIds) => {
  const filename = 'download.zip';
  const url = GALLERY_DOWNLOAD_URL(token, momentIds, filename);

  return downloadUrl(filename, url);
}

